import { Button, Heading } from '@purpur/library';
import styled from 'styled-components';
import { match } from 'ts-pattern';

import { getPurpurColor, getPurpurMotion, getPurpurSpacing } from '@telialt/common-theme/src/purpurSelectors';
import { NAVIGATION_OFFSET_CSS_VARIABLE } from '@telialt/utils/src/NavigationUtils/constants';

import { BlockLegalTextBackgroundColor, BlockLegalTextTextColor } from './model';

export const LegalTextHeading = styled(Heading)``;

type ExpandableProps = {
    $isExpanded?: boolean;
};

export const DescriptionWrapper = styled.div<ExpandableProps>`
    transition: grid-template-rows ${getPurpurMotion('duration200')} ${getPurpurMotion('easingEaseInOut')};
    display: grid;
    grid-template-rows: ${({ $isExpanded }) => ($isExpanded ? '1fr' : '0fr')};
    padding-top: ${({ $isExpanded }) => ($isExpanded ? getPurpurSpacing('100') : '0')};
    visibility: ${({ $isExpanded }) => ($isExpanded ? 'visible' : 'hidden')};
`;

export const DescriptionContainer = styled.div`
    overflow: hidden;
`;

export const ExpandButton = styled(Button)`
    margin-top: ${getPurpurSpacing('100')};
`;

type SectionProps = {
    $background: BlockLegalTextBackgroundColor;
    $textColor: BlockLegalTextTextColor;
};

export const BlockLegalTextSection = styled.section<SectionProps>`
    scroll-margin-top: var(${NAVIGATION_OFFSET_CSS_VARIABLE});
    background-color: ${({ $background }) =>
        match($background)
            .with('primary', () => getPurpurColor('backgroundPrimary'))
            .with('secondary', () => getPurpurColor('backgroundSecondary'))
            .with('tone-on-tone-primary', () => getPurpurColor('backgroundToneOnTonePrimary'))
            .with('tone-on-tone-secondary', () => getPurpurColor('backgroundToneOnToneSecondary'))
            .with('tone-on-tone-quaternary', () => getPurpurColor('backgroundToneOnToneQuaternary'))
            .exhaustive()};

    ${LegalTextHeading},
    ${DescriptionWrapper} {
        &,
        *,
        p,
        li::marker,
        blockquote {
            color: ${({ $textColor }) =>
                match($textColor)
                    .with('default', () => getPurpurColor('textDefault'))
                    .with('tone-on-tone-primary', () => getPurpurColor('textToneOnTonePrimary'))
                    .with('tone-on-tone-secondary', () => getPurpurColor('textToneOnToneSecondary'))
                    .with('tone-on-tone-tertiary', () => getPurpurColor('textToneOnToneTertiary'))
                    .with('medium-negative', () => getPurpurColor('textMediumNegative'))
                    .exhaustive()};
        }
    }
`;
